module.exports = __webpack_public_path__ + "4f018b04905f4c2ea72f147ab5fdb993.png";